import React from "react";
import Nav from "../Nav";
import Logoutmodule from "../logout/Logoutmodule";
import { useNavigate, Link } from "react-router-dom";
import Theme from "../Theme";
import { baseUrl } from "../constant";
import axios from "axios";
import { useState, useEffect } from "react";
// import Logout from '../logout/Logout'

const Seeting = () => {
  const navigate = useNavigate();
  const [notification, setnotification] = useState();
  console.log(notification);
  const getdatanotification = async () => {
    const Token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("Token", Token);

    const result = await axios.post(
      baseUrl + `authController/getNotificationList`,
      formData,
    );
    setnotification(result.data.data);
  };

  useEffect(() => {
    getdatanotification();
  }, []);

  const signout = () => {
    localStorage.removeItem("userCode");
    localStorage.removeItem("Name");
    localStorage.removeItem("token");
    navigate("/login");
  };
  const username = localStorage.getItem("Name");
  const memberID = localStorage.getItem("userCode");

  return (
    <>
      <section className="online_trade_view">
        <div className="text-center">
          <div className="onine_view_col">
            <div className="phone_frame">
              <div className="frame_screen">
                <div className="screen_body p-0">
                  <div className="dashboard_main">
                    <div
                      className="dashboard_header"
                      style={{ justifyContent: "space-between" }}
                    >
                      <Logoutmodule />
                      <div>
                        <a
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#color_modal"
                        >
                          <img
                            src="assets/img/icons/colour.png"
                            className="img-fluid color_icons"
                          />
                        </a>
                      </div>
                    </div>
                    <div
                      className="login_form tab-content dashboard_col_tabs"
                      style={{ paddingTop: "0px", height: "550px" }}
                    >
                      <div className="login_logo_us logo_f text-center">
                        <a href="#">
                          <img className="img-fluid" />
                        </a>
                      </div>
                      <div className="login_form_section">
                        <div className="login_user_details">
                          <h4>
                            Username: <span>{username}</span>
                          </h4>
                          <h5>
                            MamberID: <span>{memberID}</span>
                          </h5>
                        </div>
                        <div className="loginMarquee">
                          <h5 className="notification">
                            <marquee>
                              {notification ? (
                                notification
                                  .map((item, index) => item.message)
                                  .join(", ")
                              ) : (
                                <h1></h1>
                              )}
                            </marquee>
                          </h5>
                          {/* <marquee>
                            <h5>{notification}hfghfhfh</h5>
                          </marquee> */}
                        </div>
                        <ul className="login_nav_list">
                          <li>
                            <Link to="/wallethistory">
                              <div>
                                Wallet{" "}
                                <span>
                                  See amount add and deduct from your wallet
                                </span>
                              </div>
                              <div>
                                <i className="fa fa-chevron-right"></i>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link to="/profile">
                              <div>
                                Profile{" "}
                                <span>See/Edit your profile detail</span>
                              </div>
                              <div>
                                <i className="fa fa-chevron-right"></i>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link to="/forgotpassword">
                              <div>
                                Change Password{" "}
                                <span>Change password of your account</span>
                              </div>
                              <div>
                                <i className="fa fa-chevron-right"></i>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <Link to="/notification">
                              <div>
                                Notification{" "}
                                <span>See important notification history</span>
                              </div>
                              <div>
                                <i className="fa fa-chevron-right"></i>
                              </div>
                            </Link>
                          </li>
                          <li>
                            <a href="#">
                              <div>
                                Privacy Policy{" "}
                                <span>Know our privacy policy</span>
                              </div>
                              <div>
                                <i className="fa fa-chevron-right"></i>
                              </div>
                            </a>
                          </li>
                          <li>
                            <a href="#" onClick={signout}>
                              <div>
                                Logout <span>Logout your account</span>
                              </div>
                              <div>
                                <i className="fa fa-chevron-right"></i>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <Theme />
                    <Nav />
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Seeting;
